import React, { useEffect, useRef, useState } from "react";
import {
  Activity,
  AlertCircle,
  AlertTriangle,
  CloudSnow,
  File,
  Globe,
  Phone,
  Search,
  Settings,
  Type,
  Upload,
  User,
} from "react-feather";
import { Select } from "semantic-ui-react";
import DocumentUpload from "../../components/DocumentUpload";
import StakeholderFinanceInfo from "../../components/stakeholder/StakeholderFinanceInfo";
import StakeholderForm from "../../components/stakeholder/StakeholderForm";
import StakeholderOperationType from "../../components/stakeholder/StakeholderOperationType";
import StakeholderTypes from "../../components/stakeholder/StakeholderTypes";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import ContactComponent from "../../components/ContactComponent";
import StakeholderCluster from "../../components/stakeholder/StakeholderCluster";

import { useDispatch, useSelector } from "react-redux";
import {
  addUserCustomer,
  createUserCustomerGroup,
  getUserCustomerByUscId,
  getUserCustomerByUserId,
  getUserCustomerGroupById,
  updateUserCustomer,
  updateUserCustomerGroup,
} from "../../api/UserCustomerApi";
import {
  addCustomerShipper,
  getCustomerShipperByCustomerId,
  updateCustomerShipper,
} from "../../api/customerShipperAPI";
import {
  addAndUpload,
  deleteDocumentList,
  updateAndUpload,
} from "../../api/documentUpload";
import {
  addStakeholder,
  searchStakeholder,
  stakeholderById,
  updateStakeholder,
} from "../../api/stakeholderapi";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import UIMessage from "../../components/UIMessage";
import AlertForm from "../../components/alert/AlertForm";
import Button from "../../components/input/Button";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import SelectRenderer from "../../components/renderer/SelectRenderer";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  ScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import StakeholderConfig from "../../components/stakeholder/StakeholderConfig";
import { errorActions } from "../../store/error-slice";
import UserCustomerSearch from "../../components/stakeholder/user-customer/UserCustomerSearch";
import UserCustomerForm from "../../components/stakeholder/user-customer/UserCustomerForm";
import CustomerShipperForm from "../../components/stakeholder/customer-shipper/CustomerShipperForm";
import CustomerShipperSearch from "../../components/stakeholder/customer-shipper/CustomerShipperSearch";
import Modal from "../../components/Modal";
import DownloadGridReport from "../../components/DownloadGridReport";
import { FORMS, MODULES } from "../../const";
import Tab from "../../components/Tab";
import useNextAndPreviousAuthority from "../../hooks/useNextAndPreviousAuthority";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import StakeholderConsignmentType from "../../components/stakeholder/StakeholderConsignmentType";
import useDynamicValidation from "../../hooks/useDynamicValidation";
import {
  dynamicContactValidation,
  dynamicContactValidationStatus,
} from "../../components/validations/stakeholderCreation";
import { getAllCharges } from "../../api/finance/addChargesApi";
import StakeholderUserConfig from "../../components/stakeholder/StakeholderUserConfig";
import { userCustomerGroupValidation } from "../../components/validations/UserCustomerGroupValidation";
import UserCustomerGroupSearch from "../../components/stakeholder/UserCustomerGroupSearch";
import UserSupplierNegotiation from "../../components/stakeholder/supplier-negotiation/UserSupplierNegotiation";
import UserSupplierNegotiationSearch from "../../components/stakeholder/supplier-negotiation/UserSupplierNegotiationSearch";
import userSupplierNegotiation from "../../components/stakeholder/supplier-negotiation/UserSupplierNegotiation";
import useUserCompany from "../../hooks/useUserCompany";
import { validateFieldUserName } from "../../api/employeeApi";
import StakeholderVehicleForm from "../../components/stakeholder/stakeholder-vehicle/StakeholderVehicleForm";
import {
  addStakeholderVehicleType,
  getStakeholderVehicleTypeByCustomerShipper,
  getStakeholderVehicleTypeByStkId,
  getStakeholderVehicleTypeByStvId,
  updateStakeholderVehicleType,
} from "../../api/stakeholderVehicleApi";
import StakeholderVehicleSearch from "../../components/stakeholder/stakeholder-vehicle/StkeholderVehicleSearch";
import StakeholderVehicleTypeForm from "../../components/stakeholder/stakeholder-vehicle-type/StakeholderVehicleTypeForm";
import StakeholderVehicleTypeSearch from "../../components/stakeholder/stakeholder-vehicle-type/StkeholderVehicleTypeSearch";
import { formatFromJsonDate } from "../../dateConfig";
import CustomerConsigneeForm from "../../components/stakeholder/customer-consignee/CustomerConsigneeForm";
import {
  addCustomerConsignee,
  getCustomerConsigneesByCustomerId,
  updateCustomerConsignee,
} from "../../api/customerConsigneeAPI";
import CustomerConsigneeSearch from "../../components/stakeholder/customer-consignee/CustomerConsigneeSearch";

const FORM = FORMS.STAKEHOLDER.STK.form;

const Stakeholder = () => {
  const errorState = useSelector((state) => state.error.stakeholderErrors);
  const stkTypes = useSelector((state) => state.stk.stakeholderTypes);
  const dispatch = useDispatch();
  const [tab, setTab] = useState(1);

  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Master,
    section: FORMS.STAKEHOLDER,
  });

  const contactValidationStatus = useDynamicValidation(
    dynamicContactValidationStatus,
    "CONTACTS_1",
    true,
  );

  const [drawerTab, setDrawerTab] = useState(firstViableTab);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const userSupplierNegotiationRef = useRef(null);

  const [stakeholderCluster, setStakeholderCluster] = useState([]);
  const [stakeholderGroup, setStakeholderGroup] = useState([]);
  const [stakeholderSalesPerson, setStakeholderSalesPerson] = useState("");
  const [status, setStatus] = useState("");
  const [stakeholderType, setStakeholderType] = useState("");
  const [mainCat, setMainCat] = useState("");
  const [minCat, setMinCat] = useState("");
  const [parentComp, setParentComp] = useState("");
  const [active, setActive] = useState("");

  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);
  const [searchRes, setSearchRes] = useState([]);

  const [stkTypeList, setStkTypeList] = useState([]);

  const [editStakeholder, setEditStakeholder] = useState({});
  const [editMode, setEditMode] = useState(false);

  const company = useUserCompany();

  const { next, prev } = useNextAndPreviousAuthority({
    sectionKey: "stakeholder",
    minTab: 1,
    maxTab: 9,
    module: MODULES.Master,
    section: FORMS.STAKEHOLDER,
    currentTab: drawerTab,
    authenticated: true,
  });

  const auth = useSelector((state) => state.user.permissions[MODULES.Master]);
  const employeePermissions = auth[FORMS.STAKEHOLDER.STK.form];
  const downloadPermission = employeePermissions?.FORM?.DOWNLOAD;

  // DropdownData

  const [isLoading, setIsLoading] = useState(false);
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [cashTypeOptions, setCashTypeOptions] = useState([]);
  const [creditFromOptions, setCreditFromOptions] = useState([]);
  const [creditToOptions, setCreditToOptions] = useState([]);
  const [taxTypeOptions, setTaxTypeOptions] = useState([]);
  const [swatTypeOptions, setSwatTypeOptions] = useState([]);
  const [cat1Options, setCat1Options] = useState([]);
  const [cat2Options, setCat2Options] = useState([]);
  const [frcgApparelOptions, setFrcgApparelOptions] = useState([]);
  const [stakeTypeOptions, setStakeTypeOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [titleOptions, setTitleOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [altActiveOpt, setAltActiveOpt] = useState([]);
  const [altStatusOpt, setAltStatusOpt] = useState([]);
  const [altTypeOpt, setAltTypeOpt] = useState([]);
  const [altEventOpt, setAltEventOpt] = useState([]);
  const [consignmentTypeOptions, setConsignmentTypeOptions] = useState([]);
  const [chargeTypeOptions, setChargeTypeOptions] = useState([]);
  const [shipmentTypesOptions, setShipmentTypesOptions] = useState([]);
  const [compliance, setCompliance] = useState([]);

  // tab ref
  const stakeholderRef = useRef();
  const contactRef = useRef();
  const clusterRef = useRef();
  const typeRef = useRef();
  const financeInfoRef = useRef();
  const stakeholderOperationRef = useRef();
  const docRef = useRef();
  const configRef = useRef();
  const alertRef = useRef();
  const consignmentTypeRef = useRef();

  const stakeholderNameRef = useRef("");
  const stakeholderCodeRef = useRef("");
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  // popup
  const [showCloseButton, setShowCloseButton] = useState(false);
  const modalRef = useRef();
  const [tableData, setTableData] = useState([]);
  const [moduleName, setModuleName] = useState("stakeholder");

  const deleteWarningRef = useRef();
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [pendingSubmitEvent, setPendingSubmitEvent] = useState(null);

  // user stakeholder
  const [editUserCustomer, setEditUserCustomer] = useState({});
  const [userCustomerSearchRes, setUserCustomerSearchRes] = useState(false);
  const [uscSearchSubmitLoading, setUscSearchSubmitLoading] = useState(false);
  const [uscSearchFetchLoading, setUscSearchFetchLoading] = useState(false);
  const [uscSearchClicked, setUscSearchClicked] = useState(false);

  // tab ref user stakeholder
  const userCustomerRef = useRef();
  const userCustomerSearchRef = useRef();

  // customer shipper
  const [editCustomerShipper, setEditCustomerShipper] = useState({});
  const [customerShipperSearchRes, setCustomerShipperSearchRes] =
    useState(false);
  const [customerGroupSearchRes, setCustomerGroupSearchRes] = useState([]);
  const [cshSearchSubmitLoading, setCshSearchSubmitLoading] = useState(false);
  const [cshSearchFetchLoading, setCshSearchFetchLoading] = useState(false);
  const [cshSearchClicked, setCshSearchClicked] = useState(false);
  const [contactFormRequired, setContactFormRequired] = useState(true);
  const [stakeholderTypes, setStakeholderTypes] = useState([]);
  const [ucgSearchClicked, setUcgSearchClicked] = useState(false);
  const [ucgSearchSubmitLoading, setUcgSearchSubmitLoading] = useState(false);
  const [ucgSearchFetchLoading, setUcgSearchFetchLoading] = useState(false);
  const [userCustomerGroupResults, setUserCustomerGroupResults] = useState([]);
  const [selectedUserCustomerGroup, setSelectedUserCustomerGroup] =
    useState(null);
  const [isUcgModalOpen, setIsUcgModalOpen] = useState(false);
  const [financeFormRequired, setFinanceFormRequired] = useState(false);

  //customer consignee
  const [ccoSearchFetchLoading, setCcoSearchFetchLoading] = useState(false);
  const [editCustomerConsignee, setEditCustomerConsignee] = useState({});
  const [ccoSearchSubmitLoading, setCcoSearchSubmitLoading] = useState(false);
  const [ccoSearchClicked, setCcoSearchClicked] = useState(false);
  const [customerConsigneeSearchRes, setCustomerConsigneeSearchRes] =
    useState(false);

  // tab ref customer Consignee
  const customerConsigneeRef = useRef();

  // tab ref customer Shipper
  const customerShipperRef = useRef();
  const customerShipperSearchRef = useRef();
  const [isStkTypeError, setIsStkTypeError] = useState(false);
  const [isContactError, setIsContactError] = useState(false);

  // User Customer Group
  const userCustomerGroupRef = useRef();
  const [editUserCustomerGroup, setEditUserCustomerGroup] = useState({});

  //Stakeholder Vehicle
  const stakeholderVehicleRef = useRef();
  const stakeholderVehicleSearchRef = useRef();
  const [stakeholderVehicleSearchRes, setStakeholderVehicleSearchRes] =
    useState(false);
  const [stkVehSearchSubmitLoading, setStkVehSearchSubmitLoading] =
    useState(false);
  const [stkVehSSearchClicked, setStkVehSearchClicked] = useState(false);
  const [stkVehSearchFetchLoading, setStkVehSearchFetchLoading] =
    useState(false);
  const [editStakeholderVehicle, setEditStakeholderVehicle] = useState({});

  const user = useSelector((state) => state.user);
  const userCompany = useUserCompany();

  const isContactFormRequired = useSelector(
    (state) => state.stakeholder.contactForm,
  );

  const selectedTypes = useSelector(
    (state) => state.stakeholder.stakeholderTypes,
  );

  useEffect(() => {
    let selectedTypeIds = [];

    selectedTypes.forEach((type) => {
      selectedTypeIds.push(type.typType);
    });

    setStakeholderTypes(selectedTypeIds);
  }, [selectedTypes]);

  useEffect(() => {
    if (stakeholderTypes?.includes(7) || stakeholderTypes?.includes(9)) {
      setContactFormRequired(true);
    } else if (stakeholderTypes?.includes(1)) {
      setContactFormRequired(false);
    } else {
      setContactFormRequired(isContactFormRequired);
    }
  }, [isContactFormRequired, stakeholderTypes]);

  useEffect(() => {
    if (stakeholderTypes?.includes(7)) {
      setFinanceFormRequired(true);
    } else if (stakeholderTypes?.includes(1)) {
      setFinanceFormRequired(false);
    } else {
      setFinanceFormRequired(true);
    }
  }, [stakeholderTypes]);

  const nextButtonHandler = () => {
    switch (drawerTab) {
      case 2: {
        const stkErrors = stakeholderRef.current.validateForm();
        if (Object.entries(stkErrors).length > 0) {
          dispatch(
            errorActions.addStakeholderErrorObject({
              form: "stakeholderErrors",
              errors: stkErrors,
            }),
          );
          toast.error("Fill the required fields related to stakeholder info", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        }
        break;
      }
      case 3: {
        const contactDetails = contactRef.current.getData();
        let hasError = false;
        if (contactDetails.unmodified) {
          for (let unModContact of contactDetails.unmodified) {
            let contactErrors = dynamicContactValidation(
              unModContact,
              contactValidationStatus,
            );
            if (Object.keys(contactErrors).length !== 0) {
              dispatch(
                errorActions.addStakeholderError({
                  form: "submitErrors",
                  key: "mainContactError",
                  value: `Saved contact with code ${unModContact.conCode} does not meet the current contact requirements`,
                }),
              );
              setIsContactError(true);
              toast.error(
                `Saved contact with code ${unModContact.conCode} does not meet the current contact requirements`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
              hasError = true;
            }
          }
        }
        if (hasError) {
          return;
        }
        if (contactFormRequired) {
          const isContactDetailsInvalid = contactRef.current.validateForm();
          if (isContactDetailsInvalid) {
            dispatch(
              errorActions.addStakeholderError({
                form: "submitErrors",
                key: "mainContactError",
                value: "Should have at least one main contact detail",
              }),
            );
            setIsContactError(true);
            toast.error("There should be at least one main contact", {
              autoClose: 5000,
              containerId: "Main",
            });
            return;
          } else {
            setIsContactError(false);
          }
        }
        break;
      }
      case 1: {
        const invalidType = typeRef.current.validateForm();
        if (invalidType) {
          dispatch(
            errorActions.addStakeholderError({
              form: "submitErrors",
              key: "noTypeError",
              value: "Should have at least one stakeholder type",
            }),
          );
          setIsStkTypeError(true);
          toast.error("There should have at least one stakeholder type", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        } else {
          setIsStkTypeError(false);
        }
        break;
      }
      case 4: {
        if (financeFormRequired) {
          const financeErrors = financeInfoRef.current.validateForm();
          dispatch(
            errorActions.addStakeholderErrorObject({
              form: "financeErrors",
              errors: financeErrors,
            }),
          );
          if (Object.entries(financeErrors).length > 0) {
            toast.error("Fill the required fields related to finance info", {
              autoClose: 5000,
              containerId: "Main",
            });
            return;
          }
        }
        break;
      }
      default:
    }
    setDrawerTab(next());
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setIsSearchLoading(true);

      // New
      const {
        active,
        status,
        stakeholder_type: typeData,
        cash_type: cashTypeOpt,
        credit_from: creditFromOpt,
        credit_to: creditToOpt,
        tax_type: taxTypeOpt,
        svat_type: svatTypeOpt,
        stk_cat1: stkCat1Opt,
        stk_cat2: stkCat2Opt,
        "vpy_type#1": vpyTypeOpt,
        contact: contactOpt,
        title: titleOpt,
        departments: departmentsOpt,
        doc_type: docTypeOpt,
        "file_name#1": fileNameOpt,
        evn_type: evnTypeOpt,
        alert_type: alertTypeOpt,
        consignment_type: consignmentTypeOpt,
        request_shipment_types: requestShipmentTypeOpt,
        compliance_status: complianceStatusOpt,
      } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
        { key: "stakeholder_type" },
        { key: "cash_type" },
        { key: "credit_from" },
        { key: "credit_to" },
        { key: "tax_type" },
        { key: "svat_type" },
        { key: "stk_cat1" },
        { key: "stk_cat2" },
        { key: "vpy_type", group: "1" },
        { key: "contact" },
        { key: "title" },
        { key: "departments" },
        { key: "doc_type" },
        { key: "file_name", group: "1" },
        { key: "evn_type" },
        { key: "alert_type" },
        { key: "consignment_type" },
        { key: "request_shipment_types" },
        { key: "compliance_status" },
      ]);

      setActiveOptions(active);
      setStatusOptions(status);
      const filteredTypData = typeData.filter((typ) =>
        user.types.includes(typ.key),
      );
      setStakeTypeOptions(filteredTypData);
      setCashTypeOptions(cashTypeOpt);
      setCreditFromOptions(creditFromOpt);
      setCreditToOptions(creditToOpt);
      setTaxTypeOptions(taxTypeOpt);
      setSwatTypeOptions(svatTypeOpt);
      setCat1Options(stkCat1Opt);
      setCat2Options(stkCat2Opt);
      setFrcgApparelOptions(vpyTypeOpt);
      setTypeOptions(contactOpt);
      setTitleOptions(titleOpt);
      setDepartmentOptions(departmentsOpt);
      setDocumentTypeOptions(docTypeOpt);
      setFileNameOptions(fileNameOpt);
      setAltEventOpt(evnTypeOpt);
      setAltTypeOpt(alertTypeOpt);
      setShipmentTypesOptions(requestShipmentTypeOpt);
      setAltStatusOpt(status);
      setAltActiveOpt(active);
      setConsignmentTypeOptions(consignmentTypeOpt);
      setCompliance(complianceStatusOpt);

      const chargeTypeData = await getAllCharges();
      setChargeTypeOptions(chargeTypeData);

      setIsLoading(false);
      setIsSearchLoading(false);
    })();
  }, []);

  const [files, setFiles] = useState([]);

  const reset = () => {
    stakeholderRef?.current?.resetForm();
    //clusterRef?.current?.resetForm();
    typeRef?.current?.resetForm();
    financeInfoRef?.current?.resetForm();
    stakeholderOperationRef?.current?.resetForm();
    docRef?.current?.resetForm();
    contactRef?.current?.resetForm();
    configRef?.current?.resetForm();
    alertRef?.current?.resetForm();
    userCustomerGroupRef?.current?.resetForm();
    consignmentTypeRef?.current?.resetForm();
    customerConsigneeRef?.current?.resetForm();
    setEditMode(false);
    setEditStakeholder(null);
    setIsContactError(false);
    setIsStkTypeError(false);
    dispatch(errorActions.clearStakeholderError());
    if (tab === 1) setDrawerTab(firstViableTab);
    else if (tab === 2) setDrawerTab(10);
    else if (tab === 7) setDrawerTab(15);
    else setDrawerTab(11);
  };

  const handleSubmitUserCustomerGroup = async (e,bypassDeleteCheck = false) => {
    e.preventDefault();
    if (!bypassDeleteCheck && userCustomerGroupRef.current.isDeletedActive()) {
      setPendingSubmitEvent(e);
      setShowDeleteWarning(true);
      deleteWarningRef.current?.showModal();
      return;
    }
    setSubmitted(true);
    setIsSubmitLoading(true);

    try {
      dispatch(errorActions.clearUserCustomerGroupError());

      // ✅ Hard stop if the Group Name input has flagged a duplicate
      if (userCustomerGroupRef?.current?.hasDuplicateError?.()) {
        toast.error("Duplicate User Customer Group Name", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        return;
      }

      const data = userCustomerGroupRef?.current?.getData();
      console.log("this is the data that comes: ", data);

      const validationErrors = userCustomerGroupValidation(data);
      if (Object.keys(validationErrors).length > 0) {
        userCustomerGroupRef?.current?.setValidationErrors(validationErrors);
        dispatch(
          errorActions.validateUserCustomerGroup({
            userCustomerGroupData: data,
          }),
        );
        console.log("Please fix validation errors.");
        setIsSubmitLoading(false);
        return;
      }

      const payload = {
        ucgName: data.groupName,
        customerIds: data.customers,
        ucgStatus: data.ucgStatus,
        ucgActive: data.ucgActive,
        ucgCompany: userCompany.comId,
        createdBy: user.username,
      };

      const response = editMode
        ? await updateUserCustomerGroup(editUserCustomerGroup?.ucgId, payload)
        : await createUserCustomerGroup(payload);

      console.log("this is the response: ", response);

      if (response.status === 200) {
        toast.success(
          `User Customer Group ${editMode ? "updated" : "created"} successfully!`,
          {
            autoClose: 5000,
            containerId: "Main",
          },
        );
        userCustomerGroupRef?.current?.resetForm();
        handleDrawerClose();
      }
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while saving the User Customer Group.", {
        containerId: "Main",
      });
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleSubmitCustomerShipper = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    setIsSubmitLoading(true);

    dispatch(errorActions.clearCustomerShipperError());
    if (editMode) {
      const customerShipper = customerShipperRef.current.getData();
      const newCustomerShipper = customerShipper.created;
      const modifiedCustomerShipper = customerShipper.modified;
      const unmodifiedCustomerShipper = customerShipper.unmodified;

      if (
        newCustomerShipper.length +
          modifiedCustomerShipper.length +
          unmodifiedCustomerShipper.length <=
        0
      ) {
        dispatch(
          errorActions.validateCustomerShipper({
            customerShipperData: customerShipperRef.current.getData(),
          }),
        );
        toast.error("Should have at least one Customer Shipper Record", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        return;
      } else {
        delete customerShipper.unmodified;
      }
      try {
        const response = await updateCustomerShipper({
          updateCustomerShipperRequest: customerShipperRef.current.getData(),
          author: user.username,
        });
        if (response !== null) {
          toast.success("Customer Shipper Updated successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
          customerShipperRef.current.resetForm();
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      const customerShipper = customerShipperRef.current.getData();

      if (customerShipper.length <= 0) {
        dispatch(
          errorActions.validateCustomerShipper({
            customerShipperData: customerShipperRef.current.getData(),
          }),
        );
        toast.error("Should have at least one Customer Shipper Record", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        return;
      }
      try {
        const response = await addCustomerShipper({
          customerShipperRequest: customerShipper,
          author: user.username,
        });
        if (response !== null) {
          toast.success("Customer Shipper added successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
          customerShipperRef.current.resetForm();
        }
      } catch (e) {
        console.error(e);
      }
    }
    setIsSubmitLoading(false);
  };

  const handleSubmitCustomerConsignee = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    setIsSubmitLoading(true);

    // dispatch(errorActions.clearCustomerConsigneeError());
    if (editMode) {
      const customerConsignee = customerConsigneeRef.current.getData();

      if (
        Object.entries(customerConsignee.ccoConsignee).length === 0 ||
        !customerConsignee.ccoConsignee ||
        customerConsignee.ccoConsignee === null ||
        customerConsignee.ccoCustomer === "" ||
        customerConsignee.ccoCustomer === null
      ) {
        toast.error("Please select a Customer and Consignee", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        return;
      }
      try {
        const response = await updateCustomerConsignee({
          ...customerConsignee,
          author: user.username,
        });
        if (response.status === 200) {
          toast.success(response.data, {
            autoClose: 5000,
            containerId: "Main",
          });
          customerConsigneeRef.current.resetForm();
        }
      } catch (error) {
        const errorMessage = error.response?.data || "Something went wrong";

        toast.error(errorMessage, {
          autoClose: 5000,
          containerId: "Main",
        });

        console.error(error);
      }
    } else {
      const customerConsignee = customerConsigneeRef.current.getData();

      if (
        Object.entries(customerConsignee.ccoConsignee).length === 0 ||
        !customerConsignee.ccoConsignee ||
        customerConsignee.ccoConsignee === null ||
        customerConsignee.ccoCustomer === "" ||
        customerConsignee.ccoCustomer === null
      ) {
        toast.error("Please select a Customer and Consignee", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        return;
      }

      try {
        const response = await addCustomerConsignee({
          ...customerConsignee,
          author: user.username,
        });
        if (response.status === 200) {
          toast.success(response.data, {
            autoClose: 5000,
            containerId: "Main",
          });
          customerConsigneeRef.current.resetForm();
        }
      } catch (error) {
        const errorMessage = error.response?.data || "Something went wrong";

        toast.error(errorMessage, {
          autoClose: 5000,
          containerId: "Main",
        });

        console.error(error);
      }
    }
    setIsSubmitLoading(false);
  };

  const handleSubmitStakeholderVehType = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    setIsSubmitLoading(true);
    dispatch(errorActions.clearStakeholderVehicleTypeCusError());
    dispatch(errorActions.clearStakeholderVehicleTypeShpError());
    if (editMode) {
      const stakeholderVeh = stakeholderVehicleRef.current.getData();
      const newStakeholderVeh = stakeholderVeh.created;
      const modifiedStakeholderVeh = stakeholderVeh.modified;
      const unmodifiedStakeholderVeh = stakeholderVeh.unmodified;

      if (
        newStakeholderVeh.length +
          modifiedStakeholderVeh.length +
          unmodifiedStakeholderVeh.length <=
        0
      ) {
        dispatch(
          errorActions.validateStakeholderVehicleTypeCus({
            stakeholderVehTypeData: stakeholderVeh,
          }),
        );
        dispatch(
          errorActions.validateStakeholderVehicleTypeShp({
            stakeholderVehTypeData: stakeholderVeh,
          }),
        );
        toast.error(
          "Should have at least one Stakeholder Vehicle Type Record",
          {
            autoClose: 5000,
            containerId: "Main",
          },
        );
        setIsSubmitLoading(false);
        return;
      } else {
        delete stakeholderVeh.unmodified;
      }
      try {
        const response = await updateStakeholderVehicleType({
          stakeholderVehicleTypeUpdateContainer: stakeholderVeh,
          author: user.username,
        });
        if (response !== null) {
          toast.success("Stakeholder Vehicle Type Updated successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
          stakeholderVehicleRef.current.resetForm();
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      const stakeholderVeh = stakeholderVehicleRef.current.getData();

      if (stakeholderVeh.length <= 0) {
        dispatch(
          errorActions.validateStakeholderVehicleTypeCus({
            stakeholderVehTypeData: stakeholderVeh,
          }),
        );
        dispatch(
          errorActions.validateStakeholderVehicleTypeShp({
            stakeholderVehTypeData: stakeholderVeh,
          }),
        );
        toast.error(
          "Should have at least one Stakeholder Vehicle Type Record",
          {
            autoClose: 5000,
            containerId: "Main",
          },
        );
        setIsSubmitLoading(false);
        return;
      }
      try {
        const response = await addStakeholderVehicleType({
          stakeholderVehicleTypeCreationRequests: stakeholderVeh,
          author: user.username,
        });
        if (response !== null) {
          toast.success("Stakeholder Vehicle Type added successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
          stakeholderVehicleRef.current.resetForm();
        }
      } catch (e) {
        console.error(e);
      }
    }
    setIsSubmitLoading(false);
  };

  const handleSubmitUserCustomer = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    setIsSubmitLoading(true);

    dispatch(errorActions.clearUserCustomerError());
    if (editMode) {
      const userCustomers = userCustomerRef.current.getData();
      const newUserCustomers = userCustomers.created;
      const modifiedUserCustomers = userCustomers.modified;
      const unmodifiedUserCustomers = userCustomers.unmodified;

      const response =
        userCustomers?.deleted?.length > 0
          ? await getUserCustomerByUserId(userCustomers?.deleteRelatedUser)
          : null;
      if (response?.userCustomer.length <= 1) {
        dispatch(
          errorActions.validateUserCustomer({
            userCustomerData: userCustomerRef.current.getData(),
          }),
        );
        toast.error("Should have at least one User Stakeholder Record", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        return;
      } else {
        delete userCustomers.unmodified;
      }
      try {
        const response = await updateUserCustomer({
          userCustomerRequest: userCustomerRef.current.getData(),
          author: user.username,
        });
        if (response !== null) {
          toast.success("User Stakeholder Updated successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
          userCustomerRef.current.resetForm();
        }
      } catch (e) {}
    } else {
      const userCustomers = userCustomerRef.current.getData();
      if (userCustomers.length <= 0) {
        dispatch(
          errorActions.validateUserCustomer({
            userCustomerData: userCustomerRef.current.getData(),
          }),
        );
        toast.error("Should have at least one User Stakeholder Record", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        return;
      }
      try {
        const response = await addUserCustomer({
          userCustomer: userCustomerRef.current.getData(),
          author: user.username,
        });
        if (response !== null) {
          toast.success("User Stakeholder added successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
          userCustomerRef.current.resetForm();
        }
      } catch (e) {}
    }
    setIsSubmitLoading(false);
  };

  const handleSubmit = async (e, bypassDeleteCheck = false) => {
    e.preventDefault();
    if (!bypassDeleteCheck && (stakeholderRef.current.isDeletedActive() || financeInfoRef.current.isDeletedActive()) ) {
      setPendingSubmitEvent(e);
      setShowDeleteWarning(true);
      deleteWarningRef.current?.showModal();
      return;
    }
    setSubmitted(true);
    setIsSubmitLoading(true);

    dispatch(errorActions.clearStakeholderError());
    // const invalidType = typeRef.current.validateForm();
    const invalidType = typeRef.current?.validateForm?.();
    const stakeholderData = stakeholderRef.current.getData();

    if (typeRef.current == null) {
  console.error("typeRef is not ready");
  setIsSubmitLoading(false);
  return;
}

    if (invalidType) {
      setIsStkTypeError(true);
      toast.error("Should have at least one stakeholder type", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsSubmitLoading(false);
      return;
    } else {
      setIsStkTypeError(false);
    }

    const stakeholderErrors = stakeholderRef.current.validateForm();
    let financeErrors = {};
    if (financeFormRequired) {
      financeErrors = financeInfoRef.current.validateForm();
    }
    if (
      Object.keys(stakeholderErrors).length > 0 ||
      Object.keys(financeErrors).length > 0
    ) {
      dispatch(
        errorActions.validateStakeholder({
          stakeholderFormErrors: stakeholderErrors,
          financeFormErrors: financeErrors,
        }),
      );
      setIsSubmitLoading(false);

      if (Object.keys(stakeholderErrors).length > 0) {
        toast.error("Fill the required fields related to stakeholder info", {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error("Fill the required fields related to finance info", {
          autoClose: 5000,
          containerId: "Main",
        });
      }

      return;
    } else {
      let hasOtherErrors = false;
      const stkUser = stakeholderData.stkUserEnable;
      const contactData = contactRef.current.getData();

      if (stkUser && !editMode) {
        const mainContact =
          contactData.length > 0
            ? contactData?.find((contact) => contact.conTypeValue === "Main")
            : [];
        if (mainContact.length <= 0) {
          dispatch(
            errorActions.addEmployeeError({
              form: "submitErrors",
              key: "mainContactError",
              value: "Should have at least one main contact detail",
            }),
          );
          toast.error("Should have at least one main contact detail", {
            autoClose: 5000,
            containerId: "Main",
          });
          toast.error(
            "Stakeholder not created - Stakeholder user check box has been activated !",
            {
              autoClose: 5000,
              containerId: "Main",
            },
          );
          hasOtherErrors = true;
        } else {
          const response = await validateFieldUserName(
            "email",
            mainContact.conEmail,
          );
          if (response) {
            toast.error(
              "Stakeholder not created - Stakeholder user check box has been activated !",
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
            toast.error("User account not created - email already exists !", {
              autoClose: 5000,
              containerId: "Main",
            });
            hasOtherErrors = true;
          }
        }
      }

      if (hasOtherErrors) {
        setIsSubmitLoading(false);
        return;
      }

      if (editMode) {
        const contactDetails = contactRef.current.getData();

        const typeData = typeRef.current.getData();
        if (typeData.created.length > 0 || typeData.modified.length > 0) {
          for (let unModContact of contactDetails.unmodified) {
            let contactErrors = dynamicContactValidation(
              unModContact,
              contactValidationStatus,
            );
            if (Object.keys(contactErrors).length !== 0) {
              dispatch(
                errorActions.addStakeholderError({
                  form: "submitErrors",
                  key: "mainContactError",
                  value:
                    "Saved contacts does not meet the current contact requirements",
                }),
              );
              setIsContactError(true);
              toast.error(
                "Saved contacts does not meet the current contact requirements",
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
              setIsSubmitLoading(false);
              return;
            }
          }
        }

        const invalidType = typeRef.current.validateForm();
        if (invalidType) {
          dispatch(
            errorActions.addStakeholderError({
              form: "submitErrors",
              key: "noTypeError",
              value: "Should have at least one stakeholder type",
            }),
          );
          setIsStkTypeError(true);
          toast.error("Should have at least one stakeholder type", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        } else {
          setIsStkTypeError(false);
          delete typeData.unmodified;
        }

        if (contactFormRequired) {
          const isContactDetailsInvalid = contactRef.current.validateForm();
          if (isContactDetailsInvalid) {
            dispatch(
              errorActions.addStakeholderError({
                form: "submitErrors",
                key: "mainContactError",
                value: "Should have at least one main contact detail",
              }),
            );
            setIsContactError(true);
            toast.error("Should have at least one main contact", {
              autoClose: 5000,
              containerId: "Main",
            });
            setIsSubmitLoading(false);
            return;
          } else {
            setIsContactError(false);
            delete contactDetails.unmodified;
          }
        }

        try {
          const response = await updateStakeholder({
            stakeholder: stakeholderRef.current.getData(),
            stakeholderCluster: {
              created: [],
              modified: [],
              deleted: [],
            },
            stakeholderType: typeData,
            financeInfo: financeInfoRef.current.getData(),
            stakeholderOperation: stakeholderOperationRef.current.getData(),
            stakeholderConfig: configRef.current.getData(),
            alert: alertRef.current.getData(),
            contactDetails: contactDetails,
            author: user.username,
            consignmentType: consignmentTypeRef.current.getData(),
          });

          const data = response?.data ?? response;
          const documents = docRef.current.getData();
          let hasUploadErrors = false;

          for (let doc of documents.created) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append("documentRequest", JSON.stringify(rest));
            formData.append("isImage", rest.docCategory === 1);
            const res = await addAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              hasUploadErrors = true;
              docRef.current.markUploadFailed(doc.id ?? doc.fileName);
              toast.error(
                res?.message || `Error adding document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }
          for (let doc of documents.modified) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append("documentRequest", JSON.stringify(rest));
            formData.append("isImage", rest.docCategory === 1);
            const res = await updateAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              hasUploadErrors = true;
              docRef.current.markUploadFailed(doc.id ?? doc.fileName);
              toast.error(
                res?.message || `Error updating document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }

          if (documents?.deleted.length > 0) {
            await deleteDocumentList({
              docIdList: documents?.deleted,
            });
            toast.success("Documents deleted successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
          toast.success("Stakeholder updated successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
          if (hasUploadErrors) {
            setIsSubmitLoading(false);
            return;
          }

          if (data?.duplicatePrefix) {
            toast.warning("Warning: Modified Prefix already exists!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }

          reset();
        } catch (e) {
          if (e.response?.status === 406) {
            dispatch(
              errorActions.addStakeholderError({
                form: "stakeholderErrors",
                key: "stkName",
                value: "Stakeholder name should be unique",
              }),
            );
            toast.error("Stakeholder name should be unique!", {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            toast.error("Error Updating Stakeholder!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
          setIsSubmitLoading(false);
        }
      } else {
        const invalidType = typeRef.current.validateForm();
        if (invalidType) {
          dispatch(
            errorActions.addStakeholderError({
              form: "submitErrors",
              key: "noTypeError",
              value: "Should have at least one stakeholder type",
            }),
          );
          setIsStkTypeError(true);
          toast.error("Should have at least one stakeholder type", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        } else {
          setIsStkTypeError(false);
        }

        if (contactFormRequired) {
          const isContactDetailsInvalid = contactRef.current.validateForm();
          if (isContactDetailsInvalid) {
            dispatch(
              errorActions.addStakeholderError({
                form: "submitErrors",
                key: "mainContactError",
                value: "Should have at least one main contact detail",
              }),
            );
            setIsContactError(true);
            toast.error("Should have at least one main contact", {
              autoClose: 5000,
              containerId: "Main",
            });
            setIsSubmitLoading(false);
            return;
          } else {
            setIsContactError(false);
          }
        }

        try {
          const result = await addStakeholder({
            stakeholder: stakeholderRef.current.getData(),
            stakeholderCluster: [],
            stakeholderType: typeRef.current.getData(),
            financeInfo: [financeInfoRef.current.getData()],
            stakeholderOperation: stakeholderOperationRef.current.getData(),
            contactDetails: contactRef.current.getData(),
            stakeholderConfig: configRef.current.getData(),
            alert: alertRef.current.getData(),
            author: user.username,
            consignmentType: consignmentTypeRef.current.getData(),
          });

          const stkId = result.id;
          const duplicatePrefix = result.duplicatePrefix;

          const documents = docRef.current.getData();
          let hasUploadErrors = false;
          for (let doc of documents) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append(
              "documentRequest",
              JSON.stringify({
                ...rest,
                docReference: stkId,
              }),
            );
            formData.append("isImage", rest.docCategory === 1);
            const res = await addAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              hasUploadErrors = true;
              docRef.current.markUploadFailed(doc.id ?? doc.fileName);
              toast.error(
                res?.message || `Error adding document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }
          if (stkId !== null) {
            toast.success("Stakeholder added successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
            if (hasUploadErrors) {
              setIsSubmitLoading(false);
              return;
            }

            if (duplicatePrefix) {
              toast.warning("Warning: Prefix already exists!", {
                autoClose: 5000,
                containerId: "Main",
              });
            }

            if (stkUser) {
              toast.success("User account added successfully!", {
                autoClose: 5000,
                containerId: "Main",
              });
            }
          }
          reset();
        } catch (e) {
          if (e.response?.status === 406) {
            dispatch(
              errorActions.addStakeholderError({
                form: "stakeholderErrors",
                key: "stkName",
                value: "Stakeholder name should be unique",
              }),
            );
            toast.error("Stakeholder name should be unique!", {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            toast.error("Error Creating Stakeholder!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
          setIsSubmitLoading(false);
        }
      }
    }

    setIsSubmitLoading(false);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    reset();
  };

  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);

  const handleSearchSubmit = async (e) => {
    e.preventDefault();

    if (tab === 1) {
      setActiveAccordion1(false);
      setResetVisible(true);
      setSearchClicked(true);
      setSearchSubmitLoading(true);
    }
    const response = await searchStakeholder({
      sName: stakeholderNameRef.current.value,
      sCode: stakeholderCodeRef.current.value,
      sParentCompany: parentComp,
      sMainCat: mainCat,
      sMinCat: minCat,
      sSalesPerson: stakeholderSalesPerson,
      sStatus: status,
      sActive: active,
      sGroup: stakeholderGroup !== null ? stakeholderGroup.join(",") : null,
      // sCluster:
      //   stakeholderCluster !== null ? stakeholderCluster.join(",") : null,
      sType: stakeholderType,
      sToDate: toDateRef.current.value,
      sFromDate: fromDateRef.current.value,
    });

    setSearchRes(
      response
        ? response.map((item) => ({
            ...item,
            stkParentName: item.stkChild
              ? item.stkParentName
              : "Not a child stakeholder",
            stkMainCategoryName: item.stkMainCategory
              ? item.stkMainCategoryName
              : "No Category",
            stkMidCategoryName: item.stkMidCategory
              ? item.stkMidCategoryName
              : "No Category",
            stkSalesPersonName: item.stkSalesPerson
              ? item.stkSalesPersonName
              : "No Sales Person",
            createdDate: item.createdDate
              ? formatFromJsonDate(item.createdDate)
              : "",
            // createdDate: item.createdDate
            //   ? formatFromJsonDate(item.createdDate)
            //   : "",
          }))
        : [],
    );
    setSearchSubmitLoading(false);
  };

  const handleReset = (e) => {
    e.preventDefault();
    if (tab === 1) {
      setSearchClicked(false);
      setResetVisible(false);
    }
    if (stakeholderNameRef.current.value) {
      stakeholderNameRef.current.value = "";
    }
    if (stakeholderCodeRef.current.value) {
      stakeholderCodeRef.current.value = "";
    }
    setParentComp("");
    setMainCat("");
    setMinCat("");
    setStakeholderSalesPerson("");
    setStatus("");
    setActive("");
    setStakeholderGroup("");
    setStakeholderCluster("");
    setStakeholderType("");
  };

  const handleDrawerOpen = () => {
    if (tab === 5) {
      userSupplierNegotiationRef.current?.openDrawer();
      return;
    }
    setIsDrawerOpen(true);
    setEditMode(false);
    setEditStakeholder(null);
    dispatch(errorActions.clearStakeholderError());
    if (tab === 4) {
      setDrawerTab(12);
    } else if (tab === 6) {
      setDrawerTab(14);
    }
  };

  const handleSearchReset = (e) => {
    e.preventDefault();
    stakeholderNameRef.current.value = "";
    stakeholderCodeRef.current.value = "";
    setParentComp("");
    setMainCat("");
    setMinCat("");
    setStakeholderSalesPerson("");
    setStatus("");
    setActive("");
    setStakeholderGroup(null);
    setStakeholderCluster(null);
    setStakeholderType("");
    toDateRef.current.reset();
    fromDateRef.current.reset();
  };

  const stakeholderNameRenderer = (params) => {
    if (params.value) {
      const stkNames = params.value.split(",");
      const options = stkNames.map((stkName) => ({
        key: stkName,
        text: stkName,
        value: stkName,
      }));
      const handleChange = (selectedValue) => {};
      if (stkNames.length > 1) {
        return (
          <SelectRenderer
            onChangeHandler={handleChange}
            value={null}
            placeholder="Select Customer"
            options={options}
          />
        );
      } else {
        return <div>{params.value}</div>;
      }
    }
    return null;
  };

  const handleDownloadPopUpChange = async () => {
    setShowCloseButton(true);
    setTableData(searchRes);
    modalRef.current?.showModal();
  };

  const deleteWarningModal = (
    <div style={{ padding: "20px" }}>
      <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <AlertCircle color="red" size="25" />
        <p>Warning</p>
      </h3>
      <p>Active is set to Deleted. Are you sure you want to proceed?</p>
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <Button
          label="Cancel"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            setPendingSubmitEvent(null);
          }}
        />
       <Button
  label="Proceed"
  className="ui red button"
  onClick={() => {
    deleteWarningRef.current?.close();
    setShowDeleteWarning(false);

    const submitFn =
      drawerTab < 10
        ? handleSubmit
        : drawerTab === 10
        ? handleSubmitUserCustomer
        : drawerTab === 11
        ? handleSubmitCustomerShipper
        : drawerTab === 15
        ? handleSubmitCustomerConsignee
        : drawerTab === 14
        ? handleSubmitStakeholderVehType
        : handleSubmitUserCustomerGroup;

    submitFn({ preventDefault: () => {} }, true);

    setPendingSubmitEvent(null);
  }}
/>
      </div>
    </div>
  );

  return (
    <div>
      <Modal ref={modalRef} closeButton={showCloseButton}>
        <DownloadGridReport
          action="Custom Stakeholder Excel Download"
          tableData={tableData}
          moduleName={moduleName}
        />
      </Modal>

      <div
        className="ui tabular attached"
        style={{
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        <div className="ui tabular menu top attached">
          <Tab
            Icon={User}
            onClick={() => {
              setTab(1);
              setDrawerTab(firstViableTab);
            }}
            active={tab === 1}
            label="Stakeholder Search"
            resizeForSmallerScreens={true}
          />
          <Tab
            Icon={User}
            onClick={() => {
              setDrawerTab(10);
              setTab(2);
            }}
            active={tab === 2}
            label="User Stakeholder Search"
            resizeForSmallerScreens={true}
          />
          <Tab
            Icon={User}
            onClick={() => {
              setDrawerTab(11);
              setTab(3);
            }}
            active={tab === 3}
            label="Customer Shipper Search"
            resizeForSmallerScreens={true}
          />
          <Tab
            Icon={User}
            onClick={() => {
              setDrawerTab(12);
              setTab(4);
            }}
            active={tab === 4}
            label="User Customer Group"
            resizeForSmallerScreens={true}
          />
          <Tab
            Icon={User}
            onClick={() => {
              setDrawerTab(13);
              setTab(5);
            }}
            active={tab === 5}
            label="User Supplier Negotiation"
            resizeForSmallerScreens={true}
          />
          <Tab
            Icon={User}
            onClick={() => {
              setDrawerTab(14);
              setTab(6);
            }}
            active={tab === 6}
            label="Stakeholder Vehicle Type"
            resizeForSmallerScreens={true}
          />
          <Tab
            Icon={User}
            onClick={() => {
              setDrawerTab(15);
              setTab(7);
            }}
            active={tab === 7}
            label="Customer Consignee Search"
            resizeForSmallerScreens={true}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "0px",
          }}
          className="ui tabular menu top attached"
        >
          <Button
            template="drawerOpen"
            disabled={firstViableTab === -1}
            onClick={handleDrawerOpen}
            authenticated={true}
            form={FORMS.STAKEHOLDER.STK.form}
            module={MODULES.Master}
            editMode={false}
          />
        </div>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="four fields">
                  <div className="field">
                    <label>Stakeholder Name</label>
                    <input
                      type="text"
                      placeholder="Stakeholder Name"
                      name="stakeholderName"
                      ref={stakeholderNameRef}
                    />
                  </div>
                  <div className="field">
                    <label>Stakeholder Code</label>
                    <input
                      type="text"
                      placeholder="Stakeholder Code"
                      name="stakeholderCode"
                      ref={stakeholderCodeRef}
                    />
                  </div>

                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setStakeholderGroup("");
                    }}
                    onResultSelect={(data) => setStakeholderGroup(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stake_group",
                    }}
                    label="Stakeholder Group"
                  />

                  {/* <SearchDropdown
                        key={1}
                        editMode={false}
                        reset={searchFieldReset}
                        setReset={setSearchFieldReset}
                        clearable={true}
                        onClear={() => {
                          setStakeholderCluster("");
                        }}
                        onResultSelect={(data) => setStakeholderCluster(data)}
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "cluster",
                          value: "",
                        }}
                        label="Stakeholder Cluster"
                      /> */}
                  <div className="field">
                    <Dropdown
                      label="Stakeholder Type"
                      clearable
                      options={stakeTypeOptions}
                      placeholder="Stakeholder Type"
                      style={{ height: "20px" }}
                      value={stakeholderType}
                      onChange={(e, data) => {
                        setStakeholderType(data.value);
                      }}
                    />
                  </div>
                </div>

                <div className="four fields">
                  <SearchDropdown
                    key={1}
                    threshold={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setParentComp("");
                    }}
                    onResultSelect={(data) => setParentComp(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Customer",
                    }}
                    label="Stakeholder Parent"
                  />

                  <SearchDropdown
                    key={1}
                    threshold={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setStakeholderSalesPerson("");
                    }}
                    onResultSelect={(data) => setStakeholderSalesPerson(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "employee",
                      value: "",
                    }}
                    label="Sales Person"
                  />

                  <div className="field">
                    <label>Main Category</label>
                    <Select
                      clearable
                      options={cat1Options}
                      placeholder="Main Category"
                      style={{ height: "20px" }}
                      value={mainCat}
                      onChange={(e, data) => {
                        setMainCat(data.value);
                      }}
                    />
                  </div>

                  <div className="field">
                    <label>Min Category</label>
                    <Select
                      clearable
                      options={cat2Options}
                      placeholder="Min Category"
                      style={{ height: "20px" }}
                      value={minCat}
                      onChange={(e, data) => {
                        setMinCat(data.value);
                      }}
                    />
                  </div>
                </div>
                <div className="four fields">
                  <Input
                    label="From Date"
                    type="date"
                    name="sFromDate"
                    placeholder="To Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="sToDate"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                  <div className="field">
                    <label>Status</label>
                    <Select
                      clearable
                      options={statusOptions}
                      placeholder="Status"
                      style={{ height: "20px" }}
                      value={status}
                      onChange={(e, data) => {
                        setStatus(data.value);
                      }}
                    />
                  </div>

                  <div className="field">
                    <label>Active</label>
                    <Select
                      clearable
                      options={activeOptions}
                      placeholder="Active"
                      style={{ height: "20px" }}
                      value={active}
                      onChange={(e, data) => {
                        setActive(data.value);
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                heading="Stakeholder"
                isLoading={searchFetchLoading}
                content={searchRes}
                cellSizeStrategy="fitCellContents"
                fitContentCellls={[
                  "stkName",
                  "stkSalesPersonName",
                  "stkParentName",
                ]}
                downloadPopUpScreen={true}
                showDownloadButton={downloadPermission}
                downloadParam={""}
                downloadAction="Stakeholder Excel Download"
                handleDownloadPopUpChange={handleDownloadPopUpChange}
                config={[
                  {
                    headerName: "Id",
                    field: "stkId",
                    sort: "desc",
                    hide: true,
                  },
                  { headerName: "Code", field: "stkCode" },
                  {
                    headerName: "Name",
                    field: "stkName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Main Category",
                    field: "stkMainCategoryName",
                  },
                  {
                    headerName: "Min Category",
                    field: "stkMidCategoryName",
                  },
                  {
                    headerName: "Sales Person",
                    field: "stkSalesPersonName",
                  },
                  {
                    headerName: "Parent",
                    field: "stkParentName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Status",
                    field: "stkStatusValue",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "stkActiveValue",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await stakeholderById(props.data.stkId);
                  setEditStakeholder(response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ height: "auto", display: tab === 2 ? "block" : "none" }}
      >
        <UserCustomerSearch
          ref={userCustomerSearchRef}
          setUserCustomerSearchRes={setUserCustomerSearchRes}
          setUscSearchSubmitLoading={setUscSearchSubmitLoading}
          setUscSearchClicked={setUscSearchClicked}
        />
        {uscSearchClicked && (
          <>
            {uscSearchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={uscSearchFetchLoading}
                content={userCustomerSearchRes}
                config={[
                  {
                    headerName: "Id",
                    field: "userId",
                    sort: "desc",
                    hide: true,
                  },
                  { headerName: "Code", field: "userCode" },
                  {
                    headerName: "User Name",
                    field: "username",
                  },
                  {
                    headerName: "Customer",
                    field: "stakeholderName",
                    cellRenderer: stakeholderNameRenderer,
                  },

                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setUscSearchFetchLoading(true);
                  const stakeholderNames =
                    props.data.stakeholderName.split(",");
                  let response = [];
                  if (Object.keys(stakeholderNames).length > 1) {
                    response = await getUserCustomerByUserId(props.data.userId);
                  } else {
                    response = await getUserCustomerByUscId(props.data.uscId);
                  }

                  setDrawerTab(10);
                  setEditUserCustomer(response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setUscSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 3 ? "block" : "none" }}
      >
        <CustomerShipperSearch
          ref={customerShipperSearchRef}
          setCustomerShipperSearchRes={setCustomerShipperSearchRes}
          setCshSearchSubmitLoading={setCshSearchSubmitLoading}
          setCshSearchClicked={setCshSearchClicked}
        />
        {cshSearchClicked && (
          <>
            {cshSearchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={cshSearchFetchLoading}
                content={customerShipperSearchRes}
                config={[
                  {
                    headerName: "Id",
                    field: "cusId",
                    sort: "desc",
                    hide: true,
                  },
                  { headerName: "Code", field: "customerCode" },
                  {
                    headerName: "Customer Name",
                    field: "customerName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Shipper",
                    field: "shipperName",
                    cellRenderer: stakeholderNameRenderer,
                  },
                  {
                    headerName: "Cluster",
                    field: "clusterName",
                    cellRenderer: stakeholderNameRenderer,
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setCshSearchFetchLoading(true);
                  const response = await getCustomerShipperByCustomerId(
                    props.data.cusId,
                  );
                  setDrawerTab(11);
                  setEditCustomerShipper(response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setCshSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 4 ? "block" : "none" }}
      >
        <UserCustomerGroupSearch
          setSearchClicked={setUcgSearchClicked}
          setSearchSubmitLoading={setUcgSearchSubmitLoading}
          setSearchResults={setCustomerGroupSearchRes}
          setFetchLoading={setUcgSearchFetchLoading}
        />

        {ucgSearchClicked && (
          <>
            {ucgSearchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={ucgSearchFetchLoading}
                content={customerGroupSearchRes}
                config={[
                  { headerName: "ID", field: "ucgId", hide: true },
                  { headerName: "Code", field: "ucgCode" },
                  {
                    headerName: "Group Name",
                    field: "groupName",
                    cellRenderer: ScrollingTextRenderer,
                  },
                  {
                    headerName: "Customers",
                    field: "customers",
                    cellRenderer: ScrollingTextRenderer,
                  },
                  {
                    headerName: "Status",
                    field: "statusText",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "activeText",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  try {
                    setUcgSearchFetchLoading(true);
                    const response = await getUserCustomerGroupById(
                      props.data.ucgId,
                    );

                    // ✅ Missing piece
                    setEditUserCustomerGroup(response);
                    setEditMode(true);
                    setDrawerTab(12);

                    // ✅ This is the key line you're missing
                    setIsDrawerOpen(true);
                  } catch (error) {
                    console.error(
                      "Error fetching user customer group by ID",
                      error,
                    );
                  } finally {
                    setUcgSearchFetchLoading(false);
                  }
                }}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 5 ? "block" : "none" }}
      >
        <UserSupplierNegotiationSearch ref={userSupplierNegotiationRef} />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 6 ? "block" : "none" }}
      >
        <StakeholderVehicleTypeSearch
          setStakeholderVehicleSearchRes={setStakeholderVehicleSearchRes}
          setStkVehSearchSubmitLoading={setStkVehSearchSubmitLoading}
          setStkVehSearchClicked={setStkVehSearchClicked}
          dropdown={{
            stakeTypeOptions,
            activeOptions,
            statusOptions,
          }}
        />
        {stkVehSSearchClicked && (
          <>
            {stkVehSearchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Grid
                  heading="Stakeholder Vehicle Type"
                  isLoading={stkVehSearchFetchLoading}
                  content={stakeholderVehicleSearchRes}
                  config={[
                    {
                      headerName: "Id",
                      field: "svtId",
                      sort: "desc",
                      hide: true,
                    },
                    {
                      headerName: "Code",
                      field: "code",
                    },
                    {
                      headerName: "Stakeholder",
                      field: "stakeholder",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Stakeholder Type",
                      field: "stakeholderType",
                      cellRenderer: stakeholderNameRenderer,
                    },
                    {
                      headerName: "Vehicle Type",
                      field: "vehicleType",
                      cellRenderer: stakeholderNameRenderer,
                    },
                    {
                      headerName: "Status",
                      field: "status",
                      cellRenderer: StatusCellStyle,
                    },
                    {
                      headerName: "Active",
                      field: "active",
                      cellRenderer: ActiveCellStyle,
                    },
                  ]}
                  onCellDoubleClicked={async (props) => {
                    setStkVehSearchFetchLoading(true);
                    const vehicles = props.data.vehicleType.split(",");
                    const svts = props.data.svtId.split(",");
                    let response = [];
                    if (
                      Object.keys(vehicles).length > 1 ||
                      Object.keys(svts).length > 1
                    ) {
                      if (props.data.customerShipper === null) {
                        response = await getStakeholderVehicleTypeByStkId(
                          props.data.stkId,
                        );
                      } else {
                        response =
                          await getStakeholderVehicleTypeByCustomerShipper(
                            props.data.customerShipper,
                          );
                      }
                    } else {
                      response = await getStakeholderVehicleTypeByStvId(
                        props.data.svtId,
                      );
                    }
                    setDrawerTab(14);
                    setEditStakeholderVehicle(response);
                    setEditMode(true);
                    setIsDrawerOpen(true);
                    setStkVehSearchFetchLoading(false);
                  }}
                />
              </>
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 7 ? "block" : "none" }}
      >
        <CustomerConsigneeSearch
          ref={customerConsigneeRef}
          setCustomerConsigneeSearchRes={setCustomerConsigneeSearchRes}
          setCcoSearchSubmitLoading={setCcoSearchSubmitLoading}
          setCcoSearchClicked={setCcoSearchClicked}
        />
        {ccoSearchClicked && (
          <>
            {ccoSearchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={ccoSearchFetchLoading}
                content={customerConsigneeSearchRes}
                config={[
                  // {
                  //   headerName: "Id",
                  //   field: "ccoId",
                  //   sort: "desc",
                  //   hide: true,
                  // },
                  // {
                  //   headerName: "Code",
                  //   field: "ccoCode",
                  //   cellRenderer: stakeholderNameRenderer,
                  // },
                  {
                    headerName: "Customer Name",
                    field: "ccoCustomerName",
                    cellRenderer: ScrollingTextRenderer,
                  },
                  {
                    headerName: "Consignee Name",
                    field: "ccoConsigneeName",
                    cellRenderer: stakeholderNameRenderer,
                  },
                  {
                    headerName: "Status",
                    field: "ccoStatusName",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "ccoActiveName",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setCcoSearchFetchLoading(true);
                  const response = await getCustomerConsigneesByCustomerId(
                    props.data.ccoCustomer,
                  );
                  setDrawerTab(15);
                  setEditCustomerConsignee(response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setCcoSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          tab === 1 ? (
            editMode ? (
              <div
                className="stakeholder-code-header"
                style={{ padding: "10px 16px" }}
              >
                <h3>
                  Stakeholder Code: {editStakeholder?.stakeholder?.stkCode}
                </h3>
              </div>
            ) : null
          ) : tab === 2 ? (
            // editUserCustomer ? (
            editMode ? (
              <div
                className="stakeholder-code-header"
                style={{ padding: "10px 16px" }}
              >
                <h3>
                  User Stakeholder Name:{" "}
                  {editUserCustomer?.userResponse?.username}
                </h3>
              </div>
            ) : null
          ) : tab === 3 && editMode ? (
            <div
              className="stakeholder-code-header"
              style={{ padding: "10px 16px" }}
            >
              <h3>
                Customer Shipper Name:{" "}
                {editCustomerShipper?.customerResponse?.stkName}
              </h3>
            </div>
          ) : null
        }
        body={
          <>
            <form
              className="drawer-content"
              style={tab === 1 ? { minWidth: "80vw" } : {}}
              onSubmit={
                drawerTab < 10
                  ? handleSubmit
                  : drawerTab === 10
                    ? handleSubmitUserCustomer
                    : drawerTab === 11
                      ? handleSubmitCustomerShipper
                      : drawerTab === 15
                        ? handleSubmitCustomerConsignee
                        : drawerTab === 14
                          ? handleSubmitStakeholderVehType
                          : handleSubmitUserCustomerGroup
              }
            >
              <div className="ui top attached tabular menu">
                {tab === 1 ? (
                  <>
                    <Tab
                      Icon={Type}
                      authenticated={true}
                      onClick={() => {
                        setDrawerTab(1);
                      }}
                      active={drawerTab === 1}
                      label="Stakeholder Types"
                      form={FORMS.STAKEHOLDER.TYPE.form}
                      showMandatory={true}
                      isMandatory={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(2) ||
                        stakeholderTypes?.includes(3) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7) ||
                        stakeholderTypes?.includes(8)
                      }
                      show={true}
                      hideNonMandatory={true}
                      errors={isStkTypeError}
                      resizeForSmallerScreens={true}
                    />
                    <Tab
                      Icon={User}
                      onClick={() => {
                        setDrawerTab(2);
                      }}
                      authenticated={true}
                      active={drawerTab === 2}
                      form={FORMS.STAKEHOLDER.STK_DETAIL.form}
                      label="Stakeholder"
                      showMandatory={true}
                      isMandatory={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(2) ||
                        stakeholderTypes?.includes(3) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7) ||
                        stakeholderTypes?.includes(8) ||
                        stakeholderTypes?.includes(9)
                      }
                      show={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(2) ||
                        stakeholderTypes?.includes(3) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7) ||
                        stakeholderTypes?.includes(8) ||
                        stakeholderTypes?.includes(9)
                      }
                      errors={
                        Object.keys(errorState.stakeholderErrors).length !== 0
                      }
                      resizeForSmallerScreens={true}
                    />
                    <Tab
                      Icon={Phone}
                      authenticated={true}
                      onClick={() => {
                        setDrawerTab(3);
                      }}
                      active={drawerTab === 3}
                      label="Contacts"
                      form={`${FORMS.COMMON.CONTACTS.form}_1`}
                      showMandatory={true}
                      isMandatory={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(2) ||
                        stakeholderTypes?.includes(3) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7) ||
                        stakeholderTypes?.includes(8) ||
                        stakeholderTypes?.includes(9)
                      }
                      show={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(2) ||
                        stakeholderTypes?.includes(3) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7) ||
                        stakeholderTypes?.includes(8) ||
                        stakeholderTypes?.includes(9)
                      }
                      errors={isContactError}
                      resizeForSmallerScreens={true}
                    />
                    <Tab
                      Icon={File}
                      onClick={() => {
                        setDrawerTab(4);
                      }}
                      active={drawerTab === 4}
                      authenticated={true}
                      label="Finance Info"
                      form={FORMS.STAKEHOLDER.FINANCE_INFO.form}
                      showMandatory={true}
                      isMandatory={
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7)
                      }
                      show={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7) ||
                        stakeholderTypes?.includes(9)
                      }
                      errors={
                        Object.keys(errorState.financeErrors).length !== 0
                      }
                      resizeForSmallerScreens={true}
                    />
                    <Tab
                      Icon={Activity}
                      onClick={() => {
                        setDrawerTab(5);
                      }}
                      active={drawerTab === 5}
                      label="Operation Type"
                      form={FORMS.STAKEHOLDER.OPERATIONS.form}
                      authenticated={true}
                      showMandatory={true}
                      isMandatory={false}
                      errors={
                        Object.keys(errorState.operationTypeErrors).length !== 0
                      }
                      resizeForSmallerScreens={true}
                      show={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7)
                      }
                    />
                    <Tab
                      Icon={CloudSnow}
                      onClick={() => {
                        setDrawerTab(6);
                      }}
                      active={drawerTab === 6}
                      label="Consignment Type"
                      form={FORMS.STAKEHOLDER.CONSIGNMENT.form}
                      authenticated={true}
                      showMandatory={true}
                      isMandatory={false}
                      errors={
                        Object.keys(errorState.consignmentErrors).length !== 0
                      }
                      resizeForSmallerScreens={true}
                      show={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7)
                      }
                    />
                    <Tab
                      Icon={Settings}
                      onClick={() => {
                        setDrawerTab(7);
                      }}
                      active={drawerTab === 7}
                      form={FORMS.STAKEHOLDER.CONFIG.form}
                      authenticated={true}
                      label="Configuration"
                      showMandatory={true}
                      isMandatory={false}
                      errors={
                        Object.keys(errorState.configurationErrors).length !== 0
                      }
                      resizeForSmallerScreens={true}
                      show={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6)
                      }
                    />
                    <Tab
                      Icon={Upload}
                      onClick={() => {
                        setDrawerTab(8);
                      }}
                      active={drawerTab === 8}
                      form={`${FORMS.COMMON.DOCUMENTS.form}_1`}
                      authenticated={true}
                      label="Document"
                      showMandatory={true}
                      isMandatory={false}
                      errors={
                        Object.keys(errorState.documentUploadErrors).length !==
                        0
                      }
                      resizeForSmallerScreens={true}
                      show={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7)
                      }
                    />
                    <Tab
                      Icon={AlertTriangle}
                      onClick={() => {
                        setDrawerTab(9);
                      }}
                      active={drawerTab === 9}
                      form={`${FORMS.COMMON.ALERTS.form}_1`}
                      authenticated={true}
                      label="Alert"
                      showMandatory={true}
                      isMandatory={false}
                      errors={Object.keys(errorState.alertErrors).length !== 0}
                      resizeForSmallerScreens={true}
                      show={
                        stakeholderTypes?.includes(1) ||
                        stakeholderTypes?.includes(4) ||
                        stakeholderTypes?.includes(5) ||
                        stakeholderTypes?.includes(6) ||
                        stakeholderTypes?.includes(7)
                      }
                    />
                  </>
                ) : tab === 2 ? (
                  <>
                    <Tab
                      Icon={User}
                      onClick={() => {
                        setDrawerTab(10);
                      }}
                      active={drawerTab === 10}
                      label="User Stakeholder"
                      showMandatory={true}
                      isMandatory={false}
                    />
                  </>
                ) : tab === 4 ? (
                  <>
                    <Tab
                      Icon={Settings}
                      onClick={() => {
                        setDrawerTab(12);
                      }}
                      active={drawerTab === 12}
                      label="User Customer Group"
                      showMandatory={true}
                      isMandatory={false}
                    />
                  </>
                ) : tab === 3 ? (
                  <>
                    <Tab
                      Icon={User}
                      onClick={() => {
                        setDrawerTab(11);
                      }}
                      active={drawerTab === 11}
                      label="Customer Shipper"
                      showMandatory={true}
                      isMandatory={false}
                    />
                  </>
                ) : tab === 6 ? (
                  <>
                    <Tab
                      Icon={User}
                      onClick={() => {
                        setDrawerTab(14);
                      }}
                      active={drawerTab === 14}
                      label="Stakeholder Vehicle Type"
                      showMandatory={true}
                      isMandatory={false}
                    />
                  </>
                ) : tab === 7 ? (
                  <>
                    <Tab
                      Icon={User}
                      onClick={() => {
                        setDrawerTab(15);
                      }}
                      active={drawerTab === 15}
                      label="Customer Consignee"
                      showMandatory={true}
                      isMandatory={false}
                    />
                  </>
                ) : null}
              </div>
              {tab === 1 ? (
                <>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 2 ? "block" : "none" }}
                  >
                    <StakeholderForm
                      ref={stakeholderRef}
                      errors={errorState.stakeholderErrors}
                      dropdown={{
                        cat1Options,
                        cat2Options,
                        statusOptions,
                        activeOptions,
                        chargeTypeOptions,
                        shipmentTypesOptions,
                        compliance,
                      }}
                      currentValues={
                        editMode && editStakeholder !== null
                          ? editStakeholder?.stakeholder
                          : null
                      }
                      isLoading={isLoading}
                      editMode={editMode}
                      stkTypeList={stkTypeList}
                    />
                  </div>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 3 ? "block" : "none" }}
                  >
                    <ContactComponent
                      opeType={1}
                      ref={contactRef}
                      dropdown={{
                        typeOptions,
                        titleOptions,
                        departmentOptions,
                        statusOptions,
                        activeOptions,
                      }}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editStakeholder !== null
                          ? editStakeholder?.contactDetails
                          : null
                      }
                      useDynamicFields={true}
                      keyValue="stakeholder_type"
                      type={stkTypes.length > 0 ? stkTypes.join(",") : ""}
                    />
                  </div>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 1 ? "block" : "none" }}
                  >
                    <StakeholderTypes
                      ref={typeRef}
                      dropdown={{
                        stakeTypeOptions,
                        activeOptions,
                      }}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editStakeholder !== null
                          ? editStakeholder?.stakeholderType
                          : null
                      }
                      setStkTypeList={setStkTypeList}
                    />
                  </div>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 4 ? "block" : "none" }}
                  >
                    <StakeholderFinanceInfo
                      ref={financeInfoRef}
                      errors={errorState.financeErrors}
                      dropdown={{
                        cashTypeOptions,
                        creditFromOptions,
                        creditToOptions,
                        taxTypeOptions,
                        swatTypeOptions,
                        statusOptions,
                        activeOptions,
                      }}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editStakeholder !== null
                          ? editStakeholder?.financeInfo
                          : null
                      }
                      useDynamicFields={true}
                      keyValue="stakeholder_type"
                      type={stkTypes.length > 0 ? stkTypes.join(",") : ""}
                    />
                  </div>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 5 ? "block" : "none" }}
                  >
                    <StakeholderOperationType
                      ref={stakeholderOperationRef}
                      dropdown={{
                        frcgApparelOptions,
                        activeOptions,
                      }}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editStakeholder !== null
                          ? editStakeholder?.stakeholderOperation
                          : null
                      }
                    />
                  </div>

                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 6 ? "block" : "none" }}
                  >
                    <StakeholderConsignmentType
                      ref={consignmentTypeRef}
                      errors={errorState.consignmentErrors}
                      dropdown={{
                        statusOptions,
                        activeOptions,
                        consignmentTypeOptions,
                      }}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editStakeholder !== null
                          ? editStakeholder?.consignmentType
                          : null
                      }
                    />
                  </div>

                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 7 ? "block" : "none" }}
                  >
                    <StakeholderConfig
                      ref={configRef}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editStakeholder !== null
                          ? editStakeholder?.stakeholderConfig
                          : null
                      }
                    />
                  </div>

                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 8 ? "block" : "none" }}
                  >
                    <DocumentUpload
                      opeType={1}
                      ref={docRef}
                      files={files}
                      setFiles={setFiles}
                      reference={
                        editStakeholder
                          ? editStakeholder?.stakeholder
                            ? editStakeholder?.stakeholder.stkId
                            : null
                          : null
                      }
                      dropdown={{
                        documentTypeOptions,
                        statusOptions,
                        fileNameOptions,
                        activeOptions,
                      }}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editStakeholder !== null
                          ? editStakeholder?.document
                          : null
                      }
                    />
                  </div>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 9 ? "block" : "none" }}
                  >
                    <AlertForm
                      opeType={1}
                      ref={alertRef}
                      errors={errorState.alertErrors}
                      dropdown={{
                        altActiveOpt,
                        altStatusOpt,
                        altTypeOpt,
                        altEventOpt,
                      }}
                      isLoading={isLoading}
                      editMode={editMode}
                      module={MODULES.Master}
                      currentValues={
                        editMode && editStakeholder
                          ? editStakeholder?.alert
                          : null
                      }
                    />
                  </div>
                </>
              ) : tab === 2 ? (
                <>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 10 ? "block" : "none" }}
                  >
                    <UserCustomerForm
                      ref={userCustomerRef}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editUserCustomer
                          ? editUserCustomer.userCustomer
                          : null
                      }
                    />
                  </div>
                </>
              ) : tab === 4 ? (
                <>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 12 ? "block" : "none" }}
                  >
                    <StakeholderUserConfig
                      ref={userCustomerGroupRef}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editUserCustomerGroup
                          ? editUserCustomerGroup
                          : null
                      }
                    />
                  </div>
                </>
              ) : tab === 7 ? (
                <>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 15 ? "block" : "none" }}
                  >
                    <CustomerConsigneeForm
                      ref={customerConsigneeRef}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editCustomerConsignee
                          ? editCustomerConsignee
                          : null
                      }
                    />
                  </div>
                </>
              ) : tab === 3 ? (
                <>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 11 ? "block" : "none" }}
                  >
                    <CustomerShipperForm
                      ref={customerShipperRef}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editCustomerShipper
                          ? editCustomerShipper.customerShipperResponse
                          : null
                      }
                      currentCustomer={
                        editMode && editCustomerShipper
                          ? editCustomerShipper.customerResponse
                          : null
                      }
                    />
                  </div>
                </>
              ) : tab === 6 ? (
                <>
                  <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 14 ? "block" : "none" }}
                  >
                    <StakeholderVehicleTypeForm
                      ref={stakeholderVehicleRef}
                      isLoading={isLoading}
                      editMode={editMode}
                      currentValues={
                        editMode && editStakeholderVehicle
                          ? editStakeholderVehicle.stakeholderVehicleTypeCreationResponses
                          : null
                      }
                      dropdown={{
                        stakeTypeOptions,
                        activeOptions,
                        statusOptions,
                      }}
                    />
                  </div>
                </>
              ) : null}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/*{drawerTab > firstViableTab && drawerTab < 10 && (*/}
                  {/*  <Button*/}
                  {/*    template="back"*/}
                  {/*    tab={drawerTab - 1}*/}
                  {/*    module={MODULES.Master}*/}
                  {/*    section={FORMS.STAKEHOLDER}*/}
                  {/*    authenticated={true}*/}
                  {/*    onClick={() => setDrawerTab(prev())}*/}
                  {/*  />*/}
                  {/*)}*/}
                  {/*{drawerTab < lastViableTab && (*/}
                  {/*  <Button*/}
                  {/*    template="next"*/}
                  {/*    tab={drawerTab + 1}*/}
                  {/*    module={MODULES.Master}*/}
                  {/*    section={FORMS.STAKEHOLDER}*/}
                  {/*    authenticated={true}*/}
                  {/*    onClick={nextButtonHandler}*/}
                  {/*  />*/}
                  {/*)}*/}
                  {editMode ? (
                    <Button
                      type="submit"
                      template="create"
                      isLoading={isSubmitLoading}
                      create={!editMode}
                      form={FORMS.STAKEHOLDER.STK.form}
                      module={MODULES.Master}
                      authenticated={true}
                      editMode={editMode}
                    />
                  ) : (
                    <Button
                      type="submit"
                      template="create"
                      isLoading={isSubmitLoading}
                      create={!editMode}
                      form={FORMS.STAKEHOLDER.STK.form}
                      module={MODULES.Master}
                      authenticated={true}
                      editMode={editMode}
                    />
                  )}
                </div>
              </div>
              {submitted && errorState.hasErrors && (
                <UIMessage type="negative" width="100%" centered={false}>
                  <div className="content">
                    <div className="header">
                      There was some errors with your submission
                    </div>
                    {errorState.stakeholderErrors &&
                      Object.keys(errorState.stakeholderErrors).length > 0 && (
                        <p>
                          <div className="header">Stakeholder</div>
                          <div className="content">
                            <ul>
                              {Object.entries(errorState.stakeholderErrors).map(
                                ([_, value]) => (
                                  <li>{value}</li>
                                ),
                              )}
                            </ul>
                          </div>
                        </p>
                      )}
                    {errorState.financeErrors &&
                      Object.keys(errorState.financeErrors).length > 0 && (
                        <p>
                          <div className="header">Finance Info</div>
                          <div className="content">
                            <ul>
                              {Object.entries(errorState.financeErrors).map(
                                ([_, value]) => (
                                  <li>{value}</li>
                                ),
                              )}
                            </ul>
                          </div>
                        </p>
                      )}
                    {errorState.submitErrors &&
                      Object.keys(errorState.submitErrors).length > 0 && (
                        <p>
                          <div className="content">
                            <ul>
                              {Object.entries(errorState.submitErrors).map(
                                ([_, value]) => (
                                  <li>{value}</li>
                                ),
                              )}
                            </ul>
                          </div>
                        </p>
                      )}
                  </div>
                </UIMessage>
              )}
            </form>
            <Modal
              ref={deleteWarningRef}
              closeButton={false}
              minWidth={"300px"}
            >
              {showDeleteWarning && deleteWarningModal}
            </Modal>
          </>
        }
        style={{ width: tab === 1 ? "auto" : "60vw", boxShadow: "none" }}
      />
    </div>
  );
};

export default Stakeholder;
